export default "__VITE_ASSET__BCUnGKBV__"